












import { Component, Vue } from "vue-property-decorator";
import StandartModal from "@/components/app/standart-modal.vue";
import NavConfiguration20 from "@/components/apps-configuration/nav-configuration.vue";

@Component({ components: { StandartModal, NavConfiguration20 } })
class NavConfigurationModal extends Vue {}
export default NavConfigurationModal;
